import React, { Fragment } from "react";
//import PropTypes from "prop-types";
import { useReadContract, useSwitchChain } from "wagmi";
import { polygon } from '@wagmi/core/chains';

import { LifeformsConfig } from "../services/web3";
import { ageDays } from "../helpers/utilities";
import Loader from "./Loader";
//import "../styles/InfoPanel.css";

const EligibleLifeform = ({ id, setBridgeMint }) => {
  const { switchChain } = useSwitchChain();

  const result = useReadContract({
      ...LifeformsConfig,
      functionName: 'getLifeform',
      args: [id],
    })

  const startBridgeMint = () => {
    switchChain({ chainId: polygon.id })
    setBridgeMint(id)
  }

  return (
    <div className="eligible">
      {result.isLoading ? (
        <Fragment>
          <p>Checking lifeform {id}</p>
          <Loader/>
        </Fragment>
        ) : null}
      {result.data && result.data[2] && ageDays(result.data[2]) >= 365? (
        <Fragment>
          <p>Lifeform #{id} is {ageDays(result.data[2])} days old. It is ready for a good death.</p>
          <div className="button-parent padBottom">
            <button onClick={startBridgeMint}>Proceed</button>
          </div>
        </Fragment>
      ) : null}
    </div>
  );
};

export default EligibleLifeform;
